import React, { useState } from "react";
import { MdError } from "react-icons/md";
import Button from "../../../../components/Buttons/Button";
import usePrivacyAgree from "../../hooks/usePrivacyAgree";
import useSelectBrand from "../../../../hooks/styles/useSelectBrand";
import { useNavigate } from "react-router-dom";
import CustomModal from "../../../../components/Modal/CustomModal";

export const TableRow = ({ category, items, styles }) => {
  return (
    <tr>
      <th className="font-medium align-middle border border-neutral-200">
        {category}
      </th>
      <td className={`p-2 border align-middle border-neutral-200 ${styles}`}>
        <ul>
          {items.map((item, index) => (
            <li
              key={index}
              className="flex gap-1.5 text-neutral-500 align-middle font-medium"
            >
              {item}
            </li>
          ))}
        </ul>
      </td>
    </tr>
  );
};

const PrivacyAgree = ({ isOpen, onRequestClose }) => {
  const [checkAll, setCheckAll] = useState({ age: false });
  const { submit, loading } = usePrivacyAgree();
  const { hex } = useSelectBrand();
  const [openIndex, setOpenIndex] = useState(null);

  const navigate = useNavigate();
  const handleCheckAll = () => {
    const allChecked = checkAll.age;
    setCheckAll({
      age: !allChecked,
    });
  };

  const handleSubmit = () => {
    const allChecked = checkAll.age;
    if (allChecked) {
      submit();
    } else {
      alert("개인정보 수집 이용 동의 내역에 동의해 주세요");
    }
  };

  const onClose = () => {
    navigate(-1);
    setCheckAll({
      age: false,
    });
  };

  const handleAccordionClick = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const handleCheckChange = (type) => {
    setCheckAll((prevCheckAll) => ({
      ...prevCheckAll,
      [type]: !prevCheckAll[type],
    }));
  };

  return (
    <CustomModal
      btnClose
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="분실물 등록 개인정보 제공 동의"
      onClose={onClose}
      modalBottom
    >
      <div className="flex flex-col w-full">
        <h3 className="w-full justify-center mb-5 text-2xl font-semibold text-center flex-shrink-0">
          개인정보 수집/이용 안내
        </h3>
        <div className="flex-1 overflow-y-auto max-h-[calc(100vh-20rem)] min-h-0">
          <div className="w-full flex flex-col my-2">
        <ul className="w-full flex flex-col pl-2">
          {[
            {
              label: "(필수) 만 14세 이상입니다.",
              content: (
                <>
                  <h4 className="mb-1.5 font-semibold">
                    만14세 이상부터 서비스 이용이 가능합니다.
                  </h4>
                  <p className="text-sm font-medium text-neutral-500">
                    당사는 14세 미만 고객의 개인정보를 수집하지 않는 경우, 만
                    14세 미만의 고객들에게 서비스를 제공할 수 없는 점 양해
                    부탁드립니다.
                  </p>
                </>
              ),
              type: "age",
            },
          ].map((item, index) => (
            <li className="flex items-start gap-1" key={index}>
              <div className="py-1">
                <input
                  type="checkbox"
                  className="border-transparent checkbox checkbox-md"
                  style={{ "--chkbg": hex, "--chkfg": "#2D2D2D" }}
                  checked={checkAll[item.type]}
                  onChange={() => handleCheckChange(item.type)}
                />
              </div>
              <div
                className={`argree-collapse collapse collapse-arrow ${
                  openIndex === index ? "collapse-open" : ""
                }`}
                onClick={() => handleAccordionClick(index)}
              >
                <div className="p-1 font-medium collapse-title text-neutral-600">
                  <p>{item.label}</p>
                </div>
                <div className="collapse-content">
                  <div className="p-3.5 my-2 border border-zinc-100 rounded-[10px]">
                    {item.content}
                  </div>
                </div>
              </div>
            </li>
          ))}
        </ul>
        <p className="flex gap-2 my-3 p-3.5 text-stone-700 text-sm bg-slate-50 rounded-[20px] border border-violet-50 break-keep font-medium">
          <table className="w-full border ">
            <colgroup>
              <col className="w-1/3" />
              <col className="w-auto" />
            </colgroup>
            <tbody>
              <TableRow
                category="수집/이용 항목"
                items={[
                  "성명, 휴대전화번호, 습득/분실물, 물품보관함 접수/내용",
                ]}
              />
              <TableRow
                category="수집/이용 목적"
                items={[
                  "본인확인 절차, 습득/물품보관함물품 반환 증빙 및 분실물 접수 및 증빙, 채팅 상담서비스 제공, 민원 처리",
                ]}
              />
              <TableRow
                category="보유 및 이용기간"
                styles="p-3 font-medium underline text-base align-top border border-neutral-200"
                items={[
                  "접수 완료/물품 반환 후 3개월",
                ]}
              />
            </tbody>
          </table>
        </p>
        <span className="flex flex-col">
          <span className="inline w-full flex-row text-sm my-1 px-3.5">
            ※ 개인정보를 기재하지 않으실 수 있습니다. 단, 기재하지 않으시는 경우에는 상기 목적의 서비스 이용이 불가합니다.
          </span>
        </span>
          </div>
        </div>
        <div className="flex-shrink-0 mt-4">
          <Button onClick={!loading ? handleSubmit : null} disabled={loading}>
            {loading ? (
              <span className="loading loading-dots loading-lg"></span>
            ) : (
              "확인"
            )}
          </Button>
        </div>
      </div>
    </CustomModal>
  );
};

export default PrivacyAgree;
